import { Navigate, useLocation } from "react-router-dom";
import MainPage from "./MainPage";

const RedirectPage = () => {
  const location = useLocation();
  if (
    location.pathname.endsWith("/wp/help/faq/privacy-policy") ||
    location.pathname.endsWith("/wp/help/faq/privacy-policy/")
  ) {
    window.location.replace("https://privacy.umusic.com/uk/");
    return null;
  }
  if (location.pathname.endsWith("/help")) {
    return <Navigate to="/support" replace />;
  }
  if (location.pathname.endsWith("/bundles")) {
    return <Navigate to="/solutions/remote-collaboration" replace />;
  }

  return <MainPage></MainPage>;
};

export default RedirectPage;
